import { HttpContextToken } from '@angular/common/http';

/** Ne pas afficher de toast pour une réponse 404 (cas métier : ressource absente). */
export const SKIP_ERROR_TOAST_ON_NOT_FOUND = new HttpContextToken<boolean>(() => false);
